import gql from 'graphql-tag';

export const GET_HIGHLIGHTS = gql`
  query GetHighlights($query: HighlightQuery!) {
    getHighlights(query: $query) {
      _id
      slug
      term
    }
  }
`;

export const GET_HIGHLIGHT_BY_ID = gql`
  query GetHighlightById($id: String!) {
    getHighlightById(id: $id) {
      _id
      slug
      term
      definition {
        html
      }
    }
  }
`;
